import React, { useState } from 'react'
import KontakDiv from '../components/logo/KontakDiv'
import BgDark from '../components/Background/Index.'
import Navbar from '../components/Navbar/Index'
import Sidebar from '../components/Sidebar/Index'

const About = () => {
    const [isOpen,setOpen] = useState(false)
    const toggle = () => {
        setOpen(!isOpen)
    }
    return (
        <div id="about">
            <KontakDiv/>
            <Sidebar isOpen={isOpen} toggle={toggle}/>
            <Navbar toggle={toggle}/>
            <BgDark/>
        </div>
    )
}

export default About
